import React, { useState } from 'react';
import { Checkbox } from '@material-ui/core';
import { useStyles } from '../SelectableTable.styles';
import { SelectAllMenu } from './SelectAllMenu.component';

enum SelectionMode {
  allForPage,
  all,
}

interface SelectAllCheckboxProps {
  isChecked: boolean;
  isIndeterminate: boolean;
  disabled?: boolean;
  tabIndex?: number;
  hideCheckboxMenu?: boolean;
  forcedSelectionMode?: SelectionMode;
  onAllOnPageChange?: () => void;
  onAllChange?: () => void;
  onDeselectAllItems?: () => void;
}

const SelectAllCheckbox: React.FC<SelectAllCheckboxProps> = ({
  isChecked,
  disabled,
  tabIndex,
  hideCheckboxMenu,
  isIndeterminate,
  forcedSelectionMode,
  onAllOnPageChange,
  onAllChange,
  onDeselectAllItems,
}) => {
  const styles = useStyles();

  const [selectionMode, setSelectionMode] = useState<SelectionMode>(
    forcedSelectionMode !== undefined ? forcedSelectionMode : SelectionMode.allForPage,
  );

  const handleChange = (state: boolean) => {
    if (isIndeterminate || !state) {
      onDeselectAllItems && onDeselectAllItems();
    } else {
      selectionMode === SelectionMode.all ? onAllChange && onAllChange() : onAllOnPageChange && onAllOnPageChange();
    }
  };

  return (
    <span style={{ display: 'inline-flex' }}>
      <Checkbox
        disableRipple
        color={'primary'}
        classes={{
          root: styles.checkbox,
          indeterminate: !disabled ? styles.indeterminate : styles.indeterminateBlocked,
        }}
        checked={isChecked}
        size={'medium'}
        indeterminate={isIndeterminate}
        onChange={(event, state) => {
          handleChange(state);
        }}
        onKeyDown={(event) => {
          if (event.key === ' ') {
            handleChange(!isChecked);
            event.preventDefault();
          }
        }}
        inputProps={{ 'aria-label': 'Zaznacz wszystkie elementy' }}
        disabled={disabled}
        aria-label='checkbox'
        tabIndex={tabIndex}
      />
      {!hideCheckboxMenu && (
        <SelectAllMenu
          tabIndex={tabIndex}
          allMode={selectionMode === SelectionMode.all}
          onAllOnPageClick={() => {
            setSelectionMode(SelectionMode.allForPage);
            onAllOnPageChange && onAllOnPageChange();
          }}
          onAllClick={() => {
            setSelectionMode(SelectionMode.all);
            onAllChange && onAllChange();
          }}
        />
      )}
    </span>
  );
};

export default SelectAllCheckbox;
